<template>
  <div class="footer mainFooter">
    <div class="row">
      <div class="col-6 text-right foot_left pr-10">
        <div>กองบัญชาการตำรวจสอบสวนกลาง</div>
        <div>Central Investigation Bureau</div>
      </div>
      <div class="col-6 text-left foot_right"> 
        <img src="/logo-footer.png" height="60" width="auto" alt="E-learning" /> 
  <b style="font-size: 18px;color:#FFD300 ;">ระบบบริหารจัดตารางฝึกอบรมออนไลน์</b> 

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mainFooter",
  data() {
    return {};
  },
};
</script>
<style lang="scss">
@import "/src/assets/scss/style.scss";

// .foot_left,.foot_right{
//   display: flex;
//   flex-wrap: nowrap;
//   flex-direction: column;
//   justify-content: space-around;
// }
.mainFooter > .row {
  height: 80px;
  padding-top: 20px;
}
.foot_left {
  color: white;
  border-right: 2px solid white;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

.foot_right {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
